export function tabItem(options = {}) {
	const {
		tabSelector = '[data-tab]',
		contentSelector = '[data-tabTaget], [data-tabTarget]',
		activeClass = 'js-tab',
		defaultTab = null
	} = options;

	const tabs = Array.from(document.querySelectorAll(tabSelector));
	const contents = Array.from(document.querySelectorAll(contentSelector));
	if (tabs.length === 0 || contents.length === 0) return;

	const getTargetValue = (el) =>
		el?.getAttribute('data-tabTaget') ?? el?.getAttribute('data-tabTarget');

	const setActive = (tabValue) => {
		// タブの active 切り替え
		tabs.forEach((t) => {
			const v = t.getAttribute('data-tab');
			t.classList.toggle(activeClass, v === tabValue);
		});

		// コンテンツの active 切り替え
		contents.forEach((c) => {
			const v = getTargetValue(c);
			c.classList.toggle(activeClass, v === tabValue);
		});
	};

	// 初期表示（すでに js-tab が付いているタブがあればそれを優先）
	const preActiveTab = tabs.find((t) => t.classList.contains(activeClass));
	const initialValue =
		(preActiveTab && preActiveTab.getAttribute('data-tab')) ||
		defaultTab ||
		tabs[0].getAttribute('data-tab');

	if (initialValue) setActive(initialValue);

	// イベント委譲（どこでクリックされても data-tab を持つ要素を探す）
	document.addEventListener('click', (e) => {
		const tabEl = e.target.closest(tabSelector);
		if (!tabEl) return;

		const value = tabEl.getAttribute('data-tab');
		if (!value) return;

		setActive(value);
	});
}
